<template>
  <div
    class="lg:px-16 bg-EXPONDO-grey-5 py-2 lg:py-0 max-lg:hidden"
  >
    <NavMainBarMobile
      :categories="navCategories"
      :hide-on-sale-link="isPdpCategory"
      class="lg:hidden"
    />
    <NavMainBarDesktop
      :categories="navCategories"
      :hide-on-sale-link="isPdpCategory"
      class="max-lg:hidden"
      data-testid="desktopNavBar"
    />
  </div>
</template>
<script lang="ts">

import type { Category } from '~~/types/commercetools';
import { SIMPLE_CAROUSEL_ARROW } from '~~/types/components/SimpleCarousel/SimpleCarouselArrows';

import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export default defineComponent({
  name: 'NavMainBar',

  props: {
    categories: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];

      },
    },
    product: {
      type: Object as PropType<ProductVariantExtended | null>,
      default: () => {

        return null;

      },
    },
  },
  setup(props) {

    const { isOnProductPage } = useIsPage();

    const { categories, product } = toRefs(props);
    const arrowClass = {
      container: `absolute bg-EXPONDO-primary-10 h-full w-10 z-1 top-0
      flex items-center justify-center cursor-pointer`,
      arrow: 'text-EXPONDO-primary text-xl',
    };
    const {
      getProductFirstLevelCategoryChildren,
    } = useProductFirstLevelCategoryChildren();

    const productFirstLevelCategoryChildren = computed(() => {

      return isOnProductPage.value && product.value
        ? getProductFirstLevelCategoryChildren(categories.value, product.value)
        : [];

    });

    const navCategories = computed(() =>
      productFirstLevelCategoryChildren.value?.length ? productFirstLevelCategoryChildren.value : categories.value,
    );

    const isPdpCategory = computed(() => productFirstLevelCategoryChildren.value?.length > 0);

    return {
      SIMPLE_CAROUSEL_ARROW,
      arrowClass,
      productFirstLevelCategoryChildren,
      navCategories,
      isPdpCategory,
    };

  },
});

</script>
